// widgets
require('./widgets/app_root');
require('./widgets/chat_manager');
require('./widgets/country_links');
require('./widgets/download_app_banner');
require('./widgets/error_message_manager');
require('./widgets/googleanalytics');
require('./widgets/offline_sales_banner');
require('./widgets/usersmanager');
require('./widgets/seo_faq_box');


// app
require('./apps/app.dynpack.js');
require('./apps/app.flights');
require('./apps/app.schemas');

// handlers-order matters
require('./apps/desktop.handler.home');
require('./apps/desktop');
require('./modules/ad_blocker/ad_blocker');
